import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../../../common/entities/paginated-result.entity';
import { CorrectiveActionSummary } from '../entities/corrective-action-summary.entity';
import { DashboardFilters } from '../entities/dashboard-filters.entity';

export interface RecentCorrectiveActionsProviderPort {
  /**
   * Medidas abiertas ordenadas por prioridad, una página por vez (`filters.actionsPage`, desde 1).
   * Respeta los filtros de cliente, planta y nivel de riesgo del dashboard.
   */
  getRecent(filters?: DashboardFilters): Observable<PaginatedResult<CorrectiveActionSummary>>;
}

export const RECENT_CORRECTIVE_ACTIONS_PROVIDER_PORT =
  new InjectionToken<RecentCorrectiveActionsProviderPort>('RECENT_CORRECTIVE_ACTIONS_PROVIDER_PORT');
